import * as $ from 'jquery';
import {UIElement} from "./ui";
import '/modules/common/css/ui/radio-buttons-set.css';
import '/modules/common/css/ui/radio-buttons-set.mobile.css';
import {AbstractOptionList} from "./MultiOptionList";

/**
 * A set of radio buttons
 * @extends UIElement
 */
class RadioButtonsSet extends AbstractOptionList {

    getClassName() {
        return "RadioButtonsSet";
    }

    getUIElement() {
        if (!this.uiElement) {
            this._setValue(this.value);
            this._generateUIElements();
        }
        return this.uiElement;
    }

    _generateUIElements() {
        this.uiElement = $('<div id="' + this.id + '" class="radios-input"></div>');
        this._setOptions();
    }

    _addTriggerClick(input) {
        const self = this;
        input.click(function () {
            const isChecked = $(this).attr('ischecked')==='true';
            if (!self.mandatory && isChecked) {
                self._setValue(undefined, true);
                const newInput = self._generateInput($(this).val());
                input.replaceWith(newInput);
                self.logStat("UNSET");
                return false;
            }
            if(!isChecked){
                self._setValue($(this).val(), true);
                self.logStat('SET_VALUE {'+$(this).val()+'}');
                $('input',self.uiElement).each(function (){
                    $(this).replaceWith(self._generateInput($(this).val()));
                });
            }
        });
    }

    _setOptions() {
        this.uiElement.empty();
        for (let i = 0; i < this.values.length; i++) {
            const val = this.values[i];
            const label = $('<label val="' + val + '">' + this.labels[i] + '</label>');
            label.prepend(this._generateInput(val));
            this.uiElement.append(label);
        }
    }

    _generateInput(val) {
        const checked = val === this.value;
        const input = $('<input ' + (checked ? 'checked' : '') + ' type="radio" value="' + val + '"/>')
            .attr('ischecked', checked);
        this._addTriggerClick(input);
        return input;
    }

    _setValue(value, triggerOnChange = false) {
        this.value = value;
        if (triggerOnChange) {
            this.onChangeCallbacks.forEach(c=>c(this))
        }
    }

    setValue(value) {
        this._setValue(value,true);
        this.uiElementTemp = this.uiElement;
        this._generateUIElements();
        this.uiElementTemp.replaceWith(this.uiElement);
        this.uiElementTemp = undefined;
    }
}

export {RadioButtonsSet}